import { Component, Inject, Input, OnInit, forwardRef } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { EventDetailsPageDialogComponent } from "../../dashboard-area/event-details/event-details-page-dialog.component";
import { AlertService } from "../../dashboard-area/shared/alert.service";
import { Alert, AlertDefinition } from "../../model";
import { UiService } from "../../service/ui.service";
import { DurationFormatterPipe } from "../../shared/pipe";
import { EventSeverityPipe } from "../../shared/pipe/event-severity.pipe";

@Component({
    selector: 'daily-summary-grid-widget-event-details',
    template: require('./daily-summary-grid-widget-event-details.component.html'),
    styles: [require('./daily-summary-grid-widget-event-details.component.css')]
})
export class DailySummaryGridWidgetEventDetailsComponent implements OnInit {

    @Input() set data(data: Alert[]) {
        this._data = data;
        this.computeTableData();
    }

    @Input() timezone: string;

    @Input() locale: string;

    visibleColumns: string[];
    tableData: Alert[];
    _data: Alert[];
    clickableTable: boolean;
    dataLoaded: boolean;

    constructor(
        @Inject(forwardRef(() => EventSeverityPipe)) private eventSeverityPipe: EventSeverityPipe,
        @Inject(forwardRef(() => DurationFormatterPipe)) private durationFormatterPipe: DurationFormatterPipe,
        @Inject(forwardRef(() => MatDialog)) private dialog: MatDialog,
        @Inject(forwardRef(() => AlertService)) private alertService: AlertService,
        @Inject(forwardRef(() => UiService)) private uiService: UiService
    ) { }

    ngOnInit(): void {
        this.visibleColumns = ['title', 'severity', 'duration', 'start', 'end'];
    }

    private computeTableData(): void {
        this.dataLoaded = false;
        if (this._data?.length) {
            let tableData = this._data;
            this.alertService.getAlertDefinitions(true).then(alertDefs => {
                const alertDefMap: { [id: string]: AlertDefinition } = {};
                alertDefs.forEach(ad => alertDefMap[ad.id] = ad);
                tableData.sort((a, b) => a.startTimestamp - b.startTimestamp);
                tableData.forEach(e => {
                    e['printedSeverity'] = this.eventSeverityPipe.transform(e['eventSeverity']);
                    e['duration'] = this.durationFormatterPipe.transform({ startTimestamp: e.startTimestamp, endTimestamp: e.endTimestamp });
                });
                this.clickableTable = tableData.some(event => alertDefMap[event.alertDefinitionId] != null && !!alertDefMap[event.alertDefinitionId].templateName) || !!this.uiService.getEventDetailsTemplate();
                this.tableData = tableData;
                this.dataLoaded = true;
            });
        } else {
            this.tableData = [];
            this.dataLoaded = true;
        }
    }

    openEventDetails(element: Alert): void {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = false;
        dialogConfig.minWidth = '25%';
        dialogConfig.data = { id: element.id, isHistorical: !element.endTimestamp };
        this.dialog.open(EventDetailsPageDialogComponent, dialogConfig);
    }
}